import { DEFAULT_TOURISM_EVENT } from '@/tourism-calendar/tourism-calendar-event-view/default-tourism-event';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { UuidService } from 'src/app/common/uuid.service';
import { CategoryEvent, EventVehicle, TourismEvent } from 'src/app/tourism-events/tourism-events.model';
import { TourismVehicleOutput } from '@/tourism-events/tourism-events-full/tourism-events-vehicle-add/tourism-events-vehicle-add.component';

@Component({
	selector: 'app-transport-leads',
	templateUrl: './transport-leads.component.html',
	styleUrls: ['./transport-leads.component.css'],
})
export class TransportLeadsComponent implements OnInit {
	private itemsBeforeDataLoad = 2;
	pageFunction = '';
	yesNoQuestion = '';
	loader = false;
	editable = false;
	data: TourismEvent = DEFAULT_TOURISM_EVENT;
	tags: Array<any> = [];
	errors = {
		name: '',
		vehicle: '',
		owner: '',
		date_from: '',
		date_to: '',
		category: '',
	};
	parameters = {
		vehicles: [],
		sources: [],
		statuses: [],
		tagsList: [],
	};

	constructor(
		private readonly api: Data2Service,
		private readonly uuid: UuidService,
		private readonly infobox: InfoboxService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			this.router.navigate(['transport-leads']);
		}
		if (this.route.snapshot.params['id'] == 'add') {
			this.pageFunction = 'add';
		} else {
			this.pageFunction = 'edit';
			this.data.id = this.route.snapshot.params['id'];
		}
		this.api.get('/vehicles/?types=lead', (result, error) => {
			result.data.forEach((obj) => {
				obj.fullName = obj.name + ' (' + obj.seats + ') - ' + obj.status_name;
			});
			this.parameters.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/leadsSources/', (result, error) => {
			this.parameters.sources = result.data;
			this.loadData();
		});
		this.api.get('/tourismEventsStatuses/?type=2', (result, error) => {
			this.parameters.statuses = result.data;
			this.loadData();
		});
		this.api.get('/definitions/tagsTourismEvents/', (result, error) => {
			result.data.forEach((obj) => {
				obj.name = obj.groupName + ' / ' + obj.tag;
			});
			this.parameters.tagsList = result.data;
			this.tagList();
		});
	}

	loadData(): void {
		if (this.pageFunction != 'edit') {
			this.loader = false;
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/tourismEvents/' + this.data.id + '/', (result, error) => {
			this.data = result.data;
			this.loader = false;
		});
	}

	editUnlock() {
		this.editable = true;
	}

	submit() {
		this.loader = true;
		switch (this.pageFunction) {
			case 'add':
				this.data.id = this.uuid.generate();
				this.api.post('/tourismEvents/', this.data, (result, error) => {
					this.afterSend(result, error);
				});
				break;
			case 'edit':
				this.api.put('/tourismEvents/' + this.data.id + '/', this.data, (result, error) => {
					this.afterSend(result, error);
				});
				break;
		}
	}

	private afterSend(result, error) {
		this.loader = false;
		if (error) {
			this.data.id = null;
			return;
		}
		this.router.navigate(['transport-leads', this.data.id]);
		this.pageFunction = 'edit';
		this.editable = false;
		this.infobox.success('Zapisano');
	}

	tagAdd(data) {
		this.api.command('/tourismEvents/' + this.data.id, { cmd: 'tagAdd', data: data }, (result, error) => {
			if (error) {
				return;
			}
			this.tagList();
		});
	}

	tagDel(data) {
		this.api.command('/tourismEvents/' + this.data.id, { cmd: 'tagDel', data: data }, (result, error) => {
			if (error) {
				return;
			}
			this.tagList();
		});
	}

	setVehicles(vehicles: TourismVehicleOutput[]): void {
		this.data.vehicles = vehicles as unknown as EventVehicle[];
	}

	private tagList() {
		this.api.command('/tourismEvents/' + this.data.id, { cmd: 'tags' }, (result, error) => {
			this.tags = result.data;
		});
	}
}
